var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-1"},[_c('customer-greeting',{attrs:{"name":_vm.firstName}}),_c('next-steps'),_c('share-address'),_c('manage-request'),_c('pro-licensing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }